import { GET_ALL_FORM_SELECTBOX ,GET_ALL_FORM_RADIOS,GET_ALL_FORM_CHECKBOX} from '../../types'

const INITIAL_STATE = {
  allFormSelectbox: [],
  allFormRadios: [],
  allFormCheckbox: [],

}

const formSelectbox = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_FORM_SELECTBOX:
      return {
        ...state,
        allFormSelectbox: payload,
      }
      case GET_ALL_FORM_RADIOS:
      return {
        ...state,
        allFormRadios: payload,
      }
      case GET_ALL_FORM_CHECKBOX:
        return {
          ...state,
          allFormCheckbox: payload,
        }
    default:
      return state
  }
}

export default formSelectbox
